import React from "react";
import styles from "./kanban.module.css";

/**
 * Shared Kanban column header/empty-state (Cortex Console Design System &
 * Consistency Pass, CCDS-01/02). The caller owns the outer per-column
 * element (and its pre-existing data-testid, e.g. "agents-column-running")
 * so this component nests inside it rather than replacing it.
 */
export type KanbanColumnProps = {
  title: string;
  count: number;
  emptyLabel?: string;
  children?: React.ReactNode;
};

export function KanbanColumn({
  title,
  count,
  emptyLabel = "No sessions",
  children,
}: KanbanColumnProps) {
  const hasChildren = React.Children.count(children) > 0;
  return (
    <div data-testid="kanban-column">
      <div className={styles.columnHeader}>
        <h3 className={styles.columnTitle}>{title}</h3>
        <span className={styles.columnCount}>{count}</span>
      </div>
      {hasChildren ? children : <p className={styles.emptyColumn}>{emptyLabel}</p>}
    </div>
  );
}
